import { useState } from 'react'
import Input from '../../../../shared/components/form/input'
import Button from '../../../../shared/components/Button/Button'
import Modal from '../../../../shared/modal/Modal'
import FormLayout from '../../../../shared/components/FormLayout/FormLayout'


function FormRecord({title,data, closeModal, handleOnSubmit}) {
    const [newRecord, setNewRecord] = useState(data || "")

    function handleChange(e) {
        setNewRecord({...newRecord, date: e.target.value})
    }
    async function submit(){

       handleOnSubmit(newRecord)
    }


    return (
        <Modal
            modalStatus={true}
            changeStatus={closeModal}
            w={34}
            h={38}
            content={
                <FormLayout requiredLegend
                    title={title}
                    actions={
                        <>
                            <Button variant="save" onClick={() => { submit() }}>Salvar</Button>
                            <Button variant="cancel" onClick={closeModal}>Cancelar</Button>
                        </>
                    }
                >
                    <Input
                        type="month"
                        required text="Mês e Ano"
                        handleOnChange={handleChange}
                        value={newRecord.date || ""}
                    />
                </FormLayout>
            }
        />
    )
}

export default FormRecord
